<style lang="stylus" scoped>
@import '../css/var'
.page
  padding-top 30px
  background #F2F3F4
  min-height 100vh
</style>
<template>
  <div class="page">
   <v-cells paddingBottom="8pt" paddingTop="3pt" paddingLeft="16pt"  paddingRight="16pt">
      <v-item-cell leftText="充值详情" leftColor="black"/>
      <v-item-cell leftText="充值金额" :rightText="formatPrice(data.rechargeAmount)"/>
      <v-item-cell leftText="充值时间" :rightText="formatTime(data.rechargeTime)" rightColor='#A0A1A3'/>
      <v-item-cell leftText="充值类型"  :rightText="resource.rechargeType.values[data.rechargeType]" rightColor='#090A0A'/>
      <v-item-cell leftText="订单号"  :rightText="data.outPayTradeNo" rightColor='#090A0A'/>
    </v-cells>
  </div>
</template>
<script>
  import mixin from './mixin'
  export default {
    mixins: [mixin],
    data () {
      return {
        data: {}
      }
    },
    mounted () {
      this.setTitle('充值详情')
      let param = this.getTempParam()
      if (!param) {
        this.showToast('参数错误')
        this.delayBack()
        return
      }
      this.data = param
      this.setTitle('充值详情')
    }
  }
</script>



// WEBPACK FOOTER //
// recharge-detail.vue?5b147e6f